import React, {
    ReactElement, useContext,
    useEffect,
    useMemo, useState,
} from "react";

interface HelpContextAction {
    setArticleId(articleId: string | undefined): void;
    getArticleId(): string | undefined;
}

export const HelpContext = React.createContext<HelpContextAction>({
    setArticleId() {
        // do nothing
    },
    getArticleId() : string | undefined {
        return undefined;
    },
});

export function HelpProvider({ children }: {children: ReactElement}): (ReactElement | null) {
    const [articleId, setArticleId] = useState<string>();

    const instance = useMemo<HelpContextAction>(() => ({
        setArticleId(id: string) {
            setArticleId(id);
        },
        getArticleId() {
            return articleId;
        },
    }), [articleId]);

    return (
        <HelpContext.Provider value={instance}>
            {children}
        </HelpContext.Provider>
    );
}

export default function useArticleContext(articleId: string): void {
    const context = useContext(HelpContext) ?? {};
    context.setArticleId(articleId);

    useEffect(() => () => {
        context.setArticleId(undefined);
    }, []);
}

export function useHelpContext(): HelpContextAction {
    return useContext(HelpContext) ?? {};
}
